import { createAsyncThunk } from "@reduxjs/toolkit";
import { Flavor } from "../../../client/services";
import { toastHandler } from "../../../utils/toastHandler";
import { FindFlavor, GetFlavor } from "../../flavor/api/interface";

export const findSelectFlavor = createAsyncThunk(
  "selectFlavor/findSelectFlavor",
  async (values: FindFlavor, { rejectWithValue }) => {
    try {
      const response = await Flavor.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const searchSelectFlavor = createAsyncThunk(
  "selectFlavor/searchSelectFlavor",
  async (values: FindFlavor, { rejectWithValue }) => {
    try {
      const response = await Flavor.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);


export const getSelectFlavor = createAsyncThunk(
  'selectFlavor/getSelectFlavor',
  async ({ id }: GetFlavor, { rejectWithValue }) => {
    try {
      const response = await Flavor.get(id);

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
